import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgUndo = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="M7.872 2.373c.49.497.49 1.303 0 1.8L4.28 7.818h12.734c3.858 0 6.985 3.175 6.985 7.091C24 18.825 20.873 22 17.015 22h-1.433c-.692 0-1.254-.57-1.254-1.273s.562-1.273 1.254-1.273h1.433c2.473 0 4.477-2.035 4.477-4.545s-2.004-4.545-4.477-4.545H4.28l3.59 3.645c.49.497.49 1.303 0 1.8a1.24 1.24 0 0 1-1.772 0L.367 9.991A1.27 1.27 0 0 1 0 9.09c0-.35.14-.667.365-.897m.002-.003L6.1 2.373a1.24 1.24 0 0 1 1.773 0M.367 8.19Z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgUndo);
export default ForwardRef;
